export default "__VITE_ASSET__C$HEufZS__"